import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth-service';
import { UserStore } from '../stores/user-store';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const userStore = inject(UserStore);
  const authService = inject(AuthService);

  const clonedRequest = req.clone({
    withCredentials: true,
  });

  // Ne pas intercepter les requêtes d'authentification pour éviter les boucles
  const isAuthRequest = req.url.includes('/api/auth/refresh-token');

  if (isAuthRequest) {
    return next(clonedRequest);
  }

  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isRefreshing) {
        isRefreshing = true;

        return authService.refreshToken().pipe(
          switchMap(() => {
            isRefreshing = false;
            return next(clonedRequest);
          }),
          catchError((refreshError) => {
            isRefreshing = false;

            userStore.logout();
            router.navigate(['/login']);

            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};